module.exports = __webpack_public_path__ + "img/loan-status8.70a19645.png";